import { render, staticRenderFns } from "./ExportAllJudgmentButton.vue?vue&type=template&id=73b2b95b"
import script from "./ExportAllJudgmentButton.vue?vue&type=script&lang=js"
export * from "./ExportAllJudgmentButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports